export default __webpack_public_path__ + "static/media/new-logo.750f2cc6.svg";